import { RouteElement } from '@components'

import { ModuleLayout } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, Route, Routes } from 'react-router'

import { UserNotificationsSettings } from '../../../settings/routes/UserNotificationsSettings'
import { UserPrivacySettings } from '../../../settings/routes/UserPrivacySettings'
import { UserProfileSettings } from '../../../settings/routes/UserProfileSettings'
import { UmbrellaRoute } from '../../enums/UmbrellaRoute'
import { UmbrellaSettingsNavigation } from './elements/UmbrellaSettingsNavigation'

export const UmbrellaSettings = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <ModuleLayout
      headerBottomActions={<UmbrellaSettingsNavigation />}
      title={t('settings')}
      restoreScroll={false}
      resetScroll
    >
      {/* Relative paths: Umbrella.tsx mounts this file under a real v6 non-exact match
          (path={`${UmbrellaRoute.Settings}/*`}), which strips that /settings/user prefix before
          this file's own <Routes> ever sees the pathname. */}
      <Routes>
        <Route
          index
          element={
            <RouteElement>
              <Navigate to={UmbrellaRoute.SettingsProfile} replace />
            </RouteElement>
          }
        />
        <Route
          path="profile"
          element={
            <RouteElement>
              <UserProfileSettings />
            </RouteElement>
          }
        />
        <Route
          path="notifications"
          element={
            <RouteElement>
              <UserNotificationsSettings />
            </RouteElement>
          }
        />
        <Route
          path="privacy"
          element={
            <RouteElement>
              <UserPrivacySettings />
            </RouteElement>
          }
        />
      </Routes>
    </ModuleLayout>
  )
}
